var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSwiperNaviRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10C0.5 15.2467 4.75329 19.5 10 19.5C15.2467 19.5 19.5 15.2467 19.5 10C19.5 4.75329 15.2467 0.5 10 0.5C4.75329 0.5 0.5 4.75329 0.5 10Z",
    stroke: "#CCCCCC",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7929 10L8.14645 7.73162C7.95118 7.56425 7.95118 7.29289 8.14645 7.12553C8.34171 6.95816 8.65829 6.95816 8.85355 7.12553L11.8536 9.69695C12.0488 9.86432 12.0488 10.1357 11.8536 10.303L8.85355 12.8745C8.65829 13.0418 8.34171 13.0418 8.14645 12.8745C7.95118 12.7071 7.95118 12.4358 8.14645 12.2684L10.7929 10Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_339_3336",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 4,
    height: 6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7929 10L8.14645 7.73162C7.95118 7.56425 7.95118 7.29289 8.14645 7.12553C8.34171 6.95816 8.65829 6.95816 8.85355 7.12553L11.8536 9.69695C12.0488 9.86432 12.0488 10.1357 11.8536 10.303L8.85355 12.8745C8.65829 13.0418 8.34171 13.0418 8.14645 12.8745C7.95118 12.7071 7.95118 12.4358 8.14645 12.2684L10.7929 10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_339_3336)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSwiperNaviRight);
export default __webpack_public_path__ + "static/media/ico-swiper-navi-right.9a92102eb3d69050e892baab2db765ee.svg";
export { ForwardRef as ReactComponent };